export const COUNTRY_CODE = 'au';
export const DIAL_CODE = '61';
